import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { DateHelper } from 'src/shared/helpers/dateHelper';
import { GetInvoiceMissionTypeDescription, InvoiceMissionTypeTextEnum } from 'src/shared/models/enums/invoiceMissionTypeText.enum';
import { InvoiceMissionResponse } from 'src/shared/models/invoiceMission/invoiceMission';

type SendingSectionProps = {
  invoiceMission: InvoiceMissionResponse;
};

export const SendingSection = (props: SendingSectionProps) => {
  const { invoiceMission } = props;
  const { t } = useTranslation();

  const displayDetails = (label: string, value: string | undefined, key: string | number, fullWidth = true) => {
    return (
      value && (
        <Grid item xs={fullWidth ? 'auto' : 3} mx={2} zeroMinWidth sx={{ maxWidth: fullWidth ? '100%' : '50%' }} key={key}>
          <Typography variant='body1' component='div' sx={{ fontWeight: 500 }}>
            {label.replace(/<BR>/gi, '')}
          </Typography>
          <Typography variant='body1' component='div'>
            {value}
          </Typography>
        </Grid>
      )
    );
  };

  return (
    <GridWrapper>
      {displayDetails(
        t('invoice:invoiceMissionPage.type'),
        GetInvoiceMissionTypeDescription(invoiceMission.type as InvoiceMissionTypeTextEnum, t),
        'type',
      )}
      {displayDetails(
        t('invoice:invoiceMissionPage.numberOfInvoices'),
        t('invoice:invoiceMissionPage.invoiceCounter', { count: invoiceMission.data.totalCount }),
        'quantity',
      )}
      {displayDetails(t('invoice:invoiceMissionPage.created'), DateHelper.getDate(invoiceMission.date), 'date', false)}
    </GridWrapper>
  );
};
